<template>
  <div>
    <a-list itemLayout="horizontal" :dataSource="records">
      <a-list-item slot="renderItem" slot-scope="item">
        <a-list-item-meta :description="JSON.stringify(item.args)">
          <a slot="title"
            >By:{{ item.user_name }} / API: {{ item.url }} / Time:{{ item.datetime }}</a
          >
        </a-list-item-meta>
      </a-list-item>
    </a-list>
  </div>
</template>

<script>
export default {
  data() {
    return {
      records: [],
    };
  },
  methods: {},
  mounted() {
    this.$http.post(this.$store.state.base_url + "/operationrecord/r", {}).then((res) => {
      if (res.data.status) {
        this.records = res.data.data;
        this.records.slice(this.records.length - 100, this.records.length - 100);
        console.log(this.records.length);
      }
    });
  },
};
</script>
<style scoped></style>
